/** 
 * api接口的统一出口
 */

import shopkeeper from './shopkeeper';
import membership from './membership';


// 导出接口
export default {    
    shopkeeper,
    membership
    // ……
}




// WEBPACK FOOTER //
// ./src/service/index.js